import { api } from "../api";

const BASE_URL = "/accounting/employee-salary";

export const getEmployeeSalaryById = (id) => {
  return api.get(`${BASE_URL}/${id}`);
};
